import React from "react";
import styles from "./style.module.scss";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  driverName: string;
  driverCarNum?: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  driverName,
  driverCarNum,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>
            {driverName}
            {driverCarNum ? ` - ${driverCarNum}` : ""} - Tyre Data
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
